/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import * as types from './actionTypes';


export function gotoView(feed) {

  if(typeof feed === 'string'){
    feed = {id:feed}
  }

  return (dispatch, getState)=>{

      // const feedIndex = getState().feeds.findIndex(f=>f.id===feed.id && (feed.prefix ? feed.prefix == f.prefix : true));
          
      dispatch({
        type: types.GOTO_VIEW,
        feedIndex: feed.id
        // feedIndex: feedIndex
      })
    }
}


export function gotoRightView() {
  return {
        type: types.GOTO_RIGHT_VIEW
      }
}
export function gotoLeftView() {
	console.log("action")
  return {
        type: types.GOTO_LEFT_VIEW
      }
}